import { Spinner, SpinnerSize } from '@fluentui/react';
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from "@fluentui/react-theme-provider";
import * as Style from './RelationPlansStyle';
import React from 'react';
import TableRelationPlans, { ITableSPlansRelational } from './TableRelationPlans';

const RelationPlans = ({data, loading, error}: {data?: ITableSPlansRelational[], loading: boolean, error: any}) =>
{
    var columns = [
        "Planes de Cartera",
        "Relación",
        "Fecha Inicio",
        "Fecha Fin",
        "Estado",
        "Tipo de Plan"
    ];
    const theme = useContext(ThemeContext);
    const [savingsPlans, setSavingsPlans] = useState<ITableSPlansRelational[]>();

    useEffect(() =>
    {
        if(data !== undefined && savingsPlans === undefined)
        {
            setSavingsPlans(data);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    if(error.message)
    {
        return (<div>Error: {// @ts-ignore
            error.message}</div>)
    }
    return(
        <React.Fragment>
            <React.Fragment>
                <Style.Wrapper>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md8">
                            <Style.TitleContainer>
                                <h3 style={{marginTop: "1.4em"}}>
                                    Mis planes de cartera relacionados
                                </h3>
                            </Style.TitleContainer>
                        </div>
                    </div>
                    <Style.MainCont>
                        <Style.TableCont>
                            <Style.SubTitle theme={theme}>Planes de Cartera ({savingsPlans?.length})</Style.SubTitle>
                            <Style.TableContainer theme={theme}>
                                {loading === true && (<Spinner size={SpinnerSize.large} />)}
                                {loading === false &&
                                (
                                    <TableRelationPlans
                                        theme={theme}
                                        columnTitles={columns}
                                        rowData={savingsPlans as ITableSPlansRelational[]}
                                    />
                                )}
                            </Style.TableContainer>
                        </Style.TableCont>
                    </Style.MainCont>
                </Style.Wrapper>
            </React.Fragment>
        </React.Fragment>
    );
}

export default RelationPlans;